<ng-container *ngIf="address?.address1">
  <nz-row class="row-address">
    <i
      *ngIf="displayIcon"
      nz-col
      class="fa-l fal fa-map-marker-alt icon-address"
    ></i>
    <div nz-col>
      <ng-container [ngSwitch]="_countryCode">
        <ng-container *ngSwitchCase="'MX'">
          <app-format-address-mx
            (onAddressChange)="setInlineAddress($event)"
            [displayInline]="displayInline"
            [address]="address"
            [country]="country"
          ></app-format-address-mx>
        </ng-container>
        <ng-container *ngSwitchCase="'US'">
          <app-format-address-us
            (onAddressChange)="setInlineAddress($event)"
            [displayInline]="displayInline"
            [address]="address"
            [country]="country"
          ></app-format-address-us>
        </ng-container>
      </ng-container>
    </div>

    <span
      *ngIf="enableCopy"
      class="icon-copy"
      nz-typography
      nzCopyable
      [nzCopyText]="inlineAddress"
      [nzCopyTooltips]="null"
      [nzCopyIcons]="[copyButtonTpl, copiedButtonTpl]"
    >
    </span>
  </nz-row>
</ng-container>

<ng-template #copyButtonTpl>
  <span class="copy-button">
    <i class="fal fa-copy"></i>
  </span>
</ng-template>

<ng-template #copiedButtonTpl>
  <span class="copy-button-text">
    <i class="fal fa-check"></i>
  </span>
</ng-template>
